import React, { useEffect, useState } from "react";
import cn from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Button from "../../../../../components/Buttons/button";
import BasicModal from "../../../../../components/models/models";
import {
  getSubmissionsData,
  getCompanySubmissionData,
  selectCompanyDashboard,
  setEmptyUsageReport,
} from "../../../../../redux/slices/companyDashboardSlice";
import { getSlicedCardData } from "../lib/getSlicedCardData";
import negativeHoverIcon from "../../../../../assets/images/nagative_hover.png";

function SubmittedAndRatedServiceCards({ data }) {
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);

  const [submissionsData, setSubmissionsData] = useState({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleEmptyUsageReport = () => {
    dispatch(setEmptyUsageReport());
  };

  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-[48px] justify-center mb-10">
      <div className="flex flex-col bg-[#363D50] rounded-[32px]  max-w-[100%]">
        <div className="flex flex-col p-[24px]">
          <div className="flex items-center gap-[16px]">
            <div className="flex justify-center items-center bg-[#242B3E] p-[8px] rounded-[16px] w-[48px] h-[48px] gap-[10px]">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.6059 4.70986C20.2321 4.3058 20.9162 4.07833 21.6469 4.07833C22.1174 4.07833 22.5085 4.1881 22.8213 4.36124C23.1624 4.55004 23.5919 4.42662 23.7807 4.08556C23.9695 3.7445 23.8461 3.31496 23.505 3.12615C22.9711 2.83058 22.3426 2.66663 21.6469 2.66663C20.6087 2.66663 19.6626 2.99319 18.8405 3.52365C18.5129 3.73501 18.4187 4.17188 18.6301 4.49945C18.8414 4.82701 19.2783 4.92122 19.6059 4.70986ZM25.1227 5.14139C25.0111 4.76787 24.6179 4.55552 24.2444 4.66709C23.8708 4.77867 23.6585 5.17192 23.7701 5.54544C23.8796 5.91205 23.8916 6.31894 23.7868 6.72551C23.7018 7.0552 23.5757 7.31954 23.4238 7.529C23.2507 7.76764 23.2487 8.07824 23.3944 8.31448H23.2496C23.0641 8.14892 22.7967 8.08656 22.5454 8.17465C22.2893 8.26447 21.9896 8.31443 21.6469 8.31443C21.257 8.31443 20.941 8.63045 20.941 9.02029C20.941 9.41012 21.257 9.72614 21.6469 9.72614C21.715 9.72614 21.7828 9.72472 21.8502 9.72187C21.8759 9.72472 21.9021 9.72618 21.9286 9.72618H24.4697C25.132 9.72618 25.5392 9.85878 25.7974 10.0253C26.125 10.2366 26.5619 10.1422 26.7731 9.81462C26.9844 9.487 26.8901 9.05015 26.5624 8.83888C26.0387 8.50116 25.3837 8.33201 24.5966 8.31577C24.8487 7.95656 25.0344 7.54081 25.1538 7.07796C25.3223 6.42428 25.3062 5.7558 25.1227 5.14139ZM17.5638 6.98574C17.7557 6.64642 17.6362 6.21577 17.2969 6.02387C16.9576 5.83196 16.5269 5.95147 16.335 6.29079C16.2086 6.5144 16.0906 6.74351 15.9814 6.97661C15.873 6.74986 15.757 6.52674 15.6335 6.30865C15.4415 5.96941 15.0108 5.85009 14.6715 6.04214C14.3323 6.2342 14.213 6.66489 14.405 7.00413C14.6413 7.42144 14.8476 7.86293 15.0214 8.31448H13.4584C13.0686 8.31448 12.7526 8.6305 12.7526 9.02033C12.7526 9.41016 13.0686 9.72618 13.4584 9.72618H15.9858C15.9951 9.72636 16.0044 9.72637 16.0137 9.72618H18.5405C18.9304 9.72618 19.2464 9.41016 19.2464 9.02033C19.2464 8.6305 18.9304 8.31448 18.5405 8.31448H16.9532C17.1194 7.85724 17.3243 7.40926 17.5638 6.98574ZM8.57636 7.529C8.74948 7.76764 8.7515 8.07824 8.60571 8.31448H8.75055C8.93602 8.14892 9.20351 8.08656 9.45471 8.17465C9.71085 8.26447 10.0105 8.31443 10.3533 8.31443C10.7431 8.31443 11.0591 8.63045 11.0591 9.02029C11.0591 9.41012 10.7431 9.72614 10.3533 9.72614C10.2848 9.72614 10.2168 9.72471 10.1491 9.72183C10.1232 9.7247 10.097 9.72618 10.0703 9.72618H7.52926C6.86693 9.72618 6.45981 9.85878 6.20159 10.0253C5.87396 10.2366 5.43711 10.1422 5.22584 9.81462C5.01458 9.487 5.1089 9.05015 5.43652 8.83888C5.96051 8.50099 6.61595 8.33184 7.40356 8.31575C7.15145 7.95654 6.96572 7.5408 6.84639 7.07796C6.67785 6.42428 6.69391 5.7558 6.87745 5.14139C6.98902 4.76787 7.38227 4.55552 7.75579 4.66709C8.12932 4.77867 8.34167 5.17192 8.23009 5.54544C8.12058 5.91205 8.10856 6.31894 8.21339 6.72551C8.29839 7.0552 8.42442 7.31954 8.57636 7.529ZM27.9263 11.3907C27.8795 11.0036 27.5279 10.7278 27.1409 10.7745C26.7539 10.8213 26.478 11.1729 26.5248 11.5599C26.5863 12.0695 26.5873 12.6355 26.5873 13.2554C26.5873 13.811 26.5869 14.3278 26.5521 14.801C26.5235 15.1898 26.8155 15.5281 27.2043 15.5567C27.5931 15.5853 27.9314 15.2933 27.96 14.9046C27.999 14.3748 27.999 13.8094 27.999 13.2698V13.2329V13.2329V13.2328V13.2328C27.999 12.6384 27.999 11.9926 27.9263 11.3907ZM5.4742 11.5599C5.52094 11.1729 5.24509 10.8213 4.85807 10.7745C4.47105 10.7278 4.11942 11.0036 4.07268 11.3907C3.99998 11.9926 3.99999 12.6384 4 13.2329V13.2329V13.2698V13.2698C4 13.8094 4 14.3748 4.03896 14.9046C4.06755 15.2933 4.4059 15.5853 4.79468 15.5567C5.18346 15.5281 5.47545 15.1898 5.44686 14.801C5.41206 14.3278 5.4117 13.811 5.4117 13.2554C5.4117 12.6355 5.41265 12.0695 5.4742 11.5599ZM27.1471 17.3196C27.4077 17.0296 27.384 16.5834 27.0941 16.3227C26.8041 16.0621 26.3579 16.0859 26.0972 16.3758C25.9443 16.5459 25.6925 16.6957 25.1756 16.6957C24.7857 16.6957 24.4697 17.0118 24.4697 17.4016V19.1223C24.4697 19.5122 24.7857 19.8282 25.1756 19.8282C25.5654 19.8282 25.8814 19.5122 25.8814 19.1223V18.0362C26.391 17.9259 26.8163 17.6875 27.1471 17.3196ZM5.90172 16.3758C5.64111 16.0859 5.19482 16.0621 4.9049 16.3227C4.61499 16.5834 4.59124 17.0296 4.85185 17.3196C5.18265 17.6875 5.60792 17.9259 6.11756 18.0362V19.1223C6.11756 19.5122 6.43358 19.8282 6.82341 19.8282C7.21324 19.8282 7.52926 19.5122 7.52926 19.1223V17.4016C7.52926 17.0118 7.21324 16.6957 6.82341 16.6957C6.30649 16.6957 6.05467 16.5459 5.90172 16.3758ZM7.52926 21.4166C7.52926 21.0268 7.21324 20.7108 6.82341 20.7108C6.43358 20.7108 6.11756 21.0268 6.11756 21.4166V23.1374C6.11756 23.7131 6.25597 24.2586 6.50195 24.7404C6.67921 25.0876 7.10437 25.2254 7.45157 25.0481C7.79877 24.8708 7.93653 24.4457 7.75927 24.0985C7.61241 23.8108 7.52926 23.4848 7.52926 23.1374V21.4166ZM25.8814 21.4166C25.8814 21.0268 25.5654 20.7108 25.1756 20.7108C24.7857 20.7108 24.4697 21.0268 24.4697 21.4166V23.1374C24.4697 23.4848 24.3866 23.8108 24.2397 24.0985C24.0624 24.4457 24.2002 24.8708 24.5474 25.0481C24.8946 25.2254 25.3198 25.0876 25.497 24.7404C25.743 24.2586 25.8814 23.7131 25.8814 23.1374V21.4166ZM8.6857 25.0249C8.3385 24.8477 7.91334 24.9854 7.73608 25.3326C7.55882 25.6798 7.69658 26.105 8.04378 26.2822C8.52558 26.5282 9.07106 26.6666 9.64682 26.6666H11.5526C11.9424 26.6666 12.2585 26.3506 12.2585 25.9608C12.2585 25.5709 11.9424 25.2549 11.5526 25.2549H9.64682C9.29935 25.2549 8.97335 25.1718 8.6857 25.0249ZM23.9552 26.2822C24.3024 26.105 24.4401 25.6798 24.2629 25.3326C24.0856 24.9854 23.6605 24.8477 23.3133 25.0249C23.0256 25.1718 22.6996 25.2549 22.3521 25.2549H20.4464C20.0565 25.2549 19.7405 25.5709 19.7405 25.9608C19.7405 26.3506 20.0565 26.6666 20.4464 26.6666H22.3521C22.9279 26.6666 23.4734 26.5282 23.9552 26.2822ZM14.0937 25.2549C13.7039 25.2549 13.3878 25.5709 13.3878 25.9608C13.3878 26.3506 13.7039 26.6666 14.0937 26.6666H17.9053C18.2951 26.6666 18.6111 26.3506 18.6111 25.9608C18.6111 25.5709 18.2951 25.2549 17.9053 25.2549H14.0937ZM10.3533 4.07833C11.0863 4.07833 11.7627 4.30725 12.38 4.71314C12.7058 4.9273 13.1435 4.83684 13.3576 4.5111C13.5718 4.18536 13.4813 3.74769 13.1556 3.53354C12.3394 2.99692 11.3973 2.66663 10.3533 2.66663C9.65754 2.66663 9.02907 2.83058 8.49513 3.12615C8.15407 3.31496 8.03065 3.7445 8.21945 4.08556C8.40825 4.42662 8.83779 4.55004 9.17885 4.36124C9.49162 4.1881 9.88275 4.07833 10.3533 4.07833ZM16.7056 13.3726C16.7056 12.9827 16.3896 12.6667 15.9998 12.6667C15.6099 12.6667 15.2939 12.9827 15.2939 13.3726V16.7851H12C11.6102 16.7851 11.2941 17.1011 11.2941 17.4909C11.2941 17.8808 11.6102 18.1968 12 18.1968H15.2939V21.3334C15.2939 21.7232 15.6099 22.0392 15.9998 22.0392C16.3896 22.0392 16.7056 21.7232 16.7056 21.3334V18.1968H20C20.3898 18.1968 20.7058 17.8808 20.7058 17.4909C20.7058 17.1011 20.3898 16.7851 20 16.7851H16.7056V13.3726Z"
                  fill="white"
                />
              </svg>
            </div>

            <div className="flex flex-start flex-col gap-[2px]">
              <div className="flex gap-[2px] text-primary !text-[16px] !leading-[24px]">
                Most submitted Services
              </div>
              <span className="text-secondary !text-[14px] !leading-[20px]">
                Services opportunties discoverd by your employees
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col px-[16px]">
          {/* <div className='px-[8px]'><div className='w-[100%] h-[1px] bg-[#41485C]' /></div> */}

          <div className="flex flex-col max-w-[100%] h-[360px] px-[3px] py-[3px]">
            {getSlicedCardData(data?.most_submitted_services)?.map(
              (service, index) => (
                <div
                  key={index}
                  onClick={() => {
                    setPopup(true);
                    setState(23);
                    setSubmissionsData({
                      service_name: service?.service_name,
                      submissions: service?.submissions,
                    });
                  }}
                  className="flex justify-between items-center card-animate cursor-pointer border-t-[1px] border-[#41485C] hover:rounded-[8px] py-[25px] px-[5px]"
                >
                  <div className="flex gap-[16px] items-center">
                    <div className="flex flex-col">
                      <span className="text-primary !font-medium !text-[14px] !leading-[20px] !text-left">
                        {service?.service_name}
                      </span>
                      <span className="text-secondary !leading-[20px] !text-left">
                        {service?.service_type}
                      </span>
                    </div>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-primary !font-medium !text-[14px] !leading-[20px] !text-right">
                      {service?.submission_count}
                    </span>
                    <span className="text-secondary !leading-[20px] !text-right">
                      Submissions
                    </span>
                  </div>
                </div>
              )
            )}
            {!data?.most_submitted_services && (
              <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
                <Skeleton count={3} />
              </SkeletonTheme>
            )}

            {setPopup && (
              <BasicModal
                state={state}
                popup={popup}
                setPopup={setPopup}
                setState={setState}
                submissionsData={submissionsData}
              />
            )}
          </div>
        </div>

        <div className="flex justify-center items-center h-[49px]">
          <Link to={"/company_dashboard/service_submissions"}>
            <Button
              className={cn({
                invisible: !data?.most_submitted_services?.length,
              })}
              secondary
              hoverColor
            >
              View all
            </Button>
          </Link>
        </div>
      </div>

      <div className="flex flex-col bg-[#363D50] pb-[16px] rounded-[32px]  max-w-[100%]">
        <div className="flex flex-col p-[24px]">
          <div className="flex items-center gap-[16px]">
            <div className="flex justify-center items-center bg-[#242B3E] p-[8px] rounded-[16px] w-[48px] h-[48px] gap-[10px]">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M18.4075 6.11719C17.762 6.82136 17.2444 7.71968 16.8999 8.66671H21.4113C21.9297 8.65425 22.3388 8.51816 22.6441 8.29535C22.9604 8.0645 23.2152 7.70448 23.3538 7.16693C23.6719 5.93322 22.8697 4.66671 21.3327 4.66671C20.2375 4.66671 19.2373 5.21195 18.4075 6.11719ZM15.1642 8.66671C14.7975 7.71459 14.2804 6.81668 13.6444 6.11427C12.8247 5.20891 11.8476 4.66671 10.7555 4.66671C9.21853 4.66671 8.41634 5.93322 8.73442 7.16693C8.87302 7.70448 9.12785 8.0645 9.44414 8.29535C9.74942 8.51816 10.1585 8.65425 10.6769 8.66671H15.1642ZM16.026 7.31082C16.3941 6.54637 16.8643 5.82743 17.4246 5.21622C18.4281 4.12147 19.7612 3.33337 21.3327 3.33337C23.7957 3.33337 25.1667 5.47579 24.6449 7.49981C24.5315 7.93969 24.3549 8.3321 24.1187 8.66881C25.9044 8.73167 27.3327 10.1991 27.3327 12V14.6667C27.3327 16.0336 26.51 17.2083 25.3327 17.7227V22.6667C25.3327 24.5077 23.8403 26 21.9993 26H9.99935C8.1584 26 6.66602 24.5077 6.66602 22.6667V17.7227C5.48875 17.2083 4.66602 16.0336 4.66602 14.6667V12C4.66602 10.1695 6.14154 8.68362 7.9681 8.66685C7.73259 8.33058 7.5565 7.93884 7.44331 7.49981C6.92147 5.47579 8.29254 3.33337 10.7555 3.33337C12.3302 3.33337 13.6416 4.12451 14.6328 5.21938C15.1866 5.83101 15.6528 6.5493 16.026 7.31082ZM10.6627 10H7.99935C6.89478 10 5.99935 10.8955 5.99935 12V14.6667C5.99935 15.7713 6.89478 16.6667 7.99935 16.6667H15.3327V10H10.7555V10.001C10.7245 10.001 10.6935 10.0007 10.6627 10ZM21.3327 10.001V10H16.666V16.6667H23.9993C25.1039 16.6667 25.9993 15.7713 25.9993 14.6667V12C25.9993 10.8955 25.1039 10 23.9993 10H21.4255C21.3947 10.0007 21.3637 10.001 21.3327 10.001ZM16.666 18H23.9993V22.6667C23.9993 23.7713 23.1039 24.6667 21.9993 24.6667H16.666V18ZM15.3327 18V24.6667H9.99935C8.89478 24.6667 7.99935 23.7713 7.99935 22.6667V18H15.3327Z"
                  fill="white"
                />
              </svg>
            </div>

            <div className="flex flex-start flex-col gap-[2px]">
              <div className="flex gap-[2px] text-primary !text-[16px] !leading-[24px]">
                Lowest rated services
              </div>
              <span className="text-secondary !text-[14px] !leading-[20px]">
                Services that aren't doing to well
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col px-[16px]">
          {/* <div className='px-[8px]'><div className='w-[100%] h-[1px] bg-[#41485C]' /></div> */}

          <div className="flex flex-col max-w-[100%] h-[360px] px-[3px] py-[3px]">
            {getSlicedCardData(data?.lowest_rated_services)?.map(
              (service, index) => (
                <div
                  key={index}
                  onClick={() => {
                    navigate(
                      `/company_dashboard/home/service_report/${service.id}`
                    );
                    handleEmptyUsageReport();
                  }}
                  className="flex justify-between items-center card-animate cursor-pointer py-[25px] px-[5px] border-t-[1px] border-[#41485C] hover:rounded-[8px]"
                >
                  <div className="flex gap-[16px] items-center">
                    <img
                      src={service.image_url}
                      alt="company-logo"
                      className="w-[40px] h-[40px] rounded-[8px] card_img"
                    />
                    <div className="flex flex-col">
                      <span className="text-primary !font-medium !text-[14px] !leading-[20px] !text-left">
                        {service?.service_name}
                      </span>
                      <span className="text-secondary !leading-[20px] !text-left">
                        {service?.category_name}
                      </span>
                    </div>
                  </div>
                  <div className="flex gap-[8px]">
                    <div className="flex flex-col justify-center items-center">
                      <span className="text-primary !font-medium !text-[14px] !leading-[20px] !text-right">
                        {service.positive_rating_count}
                      </span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M12.1667 3.5C7.3802 3.5 3.5 7.3802 3.5 12.1667C3.5 16.9531 7.3802 20.8333 12.1667 20.8333C16.9531 20.8333 20.8333 16.9531 20.8333 12.1667C20.8333 7.3802 16.9531 3.5 12.1667 3.5ZM2.5 12.1667C2.5 6.82791 6.82791 2.5 12.1667 2.5C17.5054 2.5 21.8333 6.82791 21.8333 12.1667C21.8333 17.5054 17.5054 21.8333 12.1667 21.8333C6.82791 21.8333 2.5 17.5054 2.5 12.1667ZM8.5 8.87085C8.77614 8.87085 9 9.09471 9 9.37085V9.46252C9 9.73866 8.77614 9.96252 8.5 9.96252C8.22386 9.96252 8 9.73866 8 9.46252V9.37085C8 9.09471 8.22386 8.87085 8.5 8.87085ZM15.8333 8.87085C16.1095 8.87085 16.3333 9.09471 16.3333 9.37085V9.46252C16.3333 9.73866 16.1095 9.96252 15.8333 9.96252C15.5572 9.96252 15.3333 9.73866 15.3333 9.46252V9.37085C15.3333 9.09471 15.5572 8.87085 15.8333 8.87085ZM8.97434 13.8419C8.88702 13.5799 8.60386 13.4383 8.34189 13.5257C8.07991 13.613 7.93833 13.8961 8.02566 14.1581C8.53003 15.6712 9.86333 17.25 12.1667 17.25C14.47 17.25 15.8033 15.6712 16.3077 14.1581C16.395 13.8961 16.2534 13.613 15.9914 13.5257C15.7295 13.4383 15.4463 13.5799 15.359 13.8419C14.9467 15.0788 13.915 16.25 12.1667 16.25C10.4183 16.25 9.38664 15.0788 8.97434 13.8419Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <div className="flex flex-col justify-center items-center">
                      <span className="text-primary !font-medium !text-[14px] !leading-[20px] !text-right">
                        {service.general_rating_count}
                      </span>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M3.5 12.1667C3.5 7.3802 7.3802 3.5 12.1667 3.5C16.9531 3.5 20.8333 7.3802 20.8333 12.1667C20.8333 16.9531 16.9531 20.8333 12.1667 20.8333C7.3802 20.8333 3.5 16.9531 3.5 12.1667ZM12.1667 2.5C6.82791 2.5 2.5 6.82791 2.5 12.1667C2.5 17.5054 6.82791 21.8333 12.1667 21.8333C17.5054 21.8333 21.8333 17.5054 21.8333 12.1667C21.8333 6.82791 17.5054 2.5 12.1667 2.5ZM9 9.37085C9 9.09471 8.77614 8.87085 8.5 8.87085C8.22386 8.87085 8 9.09471 8 9.37085V9.46252C8 9.73866 8.22386 9.96252 8.5 9.96252C8.77614 9.96252 9 9.73866 9 9.46252V9.37085ZM16.3333 9.37085C16.3333 9.09471 16.1095 8.87085 15.8333 8.87085C15.5572 8.87085 15.3333 9.09471 15.3333 9.37085V9.46252C15.3333 9.73866 15.5572 9.96252 15.8333 9.96252C16.1095 9.96252 16.3333 9.73866 16.3333 9.46252V9.37085ZM8.5 13.5C8.22386 13.5 8 13.7239 8 14C8 14.2762 8.22386 14.5 8.5 14.5H15.8333C16.1095 14.5 16.3333 14.2762 16.3333 14C16.3333 13.7239 16.1095 13.5 15.8333 13.5H8.5Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    <div className="flex flex-col justify-center items-center">
                      <span className="text-primary !font-medium !text-[14px] !leading-[20px] !text-right">
                        {service.negative_rating_count}
                      </span>
                      <img
                        className="w-[24px]"
                        src={negativeHoverIcon}
                        alt="negative icon"
                      />
                    </div>
                  </div>
                </div>
              )
            )}
            {!data?.lowest_rated_services && (
              <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
                <Skeleton count={3} />
              </SkeletonTheme>
            )}
          </div>
        </div>

        <div className="flex justify-center items-center h-[49px]">
          <Link to={"/company_dashboard/services"}>
            <Button
              className={cn({
                invisible: !data?.lowest_rated_services?.length,
              })}
              secondary
              hoverColor
            >
              View all
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SubmittedAndRatedServiceCards;
